export const systemFlowSteps = [
  { number: "01", title: "Brief", subtitle: "Goals · Scope", phase: "Discovery" },
  { number: "02", title: "UX / UI", subtitle: "Flows · Screens", phase: "Discovery" },
  { number: "03", title: "Frontend", subtitle: "React · UI", phase: "Build" },
  { number: "04", title: "API / Backend", subtitle: "Logic · Security", phase: "Build" },
  { number: "05", title: "Data & AI", subtitle: "DB · Models · Auto", phase: "Build" },
  { number: "06", title: "Release", subtitle: "Deploy · Monitor", phase: "Delivery" },
];

export const systemFlowDirections = ["right", "right", "down", "left", "left"];
